import { ReactElement, ReactNode } from "react";
import { Hide, Show } from "@chakra-ui/react";
import { MOBILE_BREAKPOINT_SIZE } from "util/styleHelpers";

export const DesktopOnly = ({
  children,
}: {
  children: ReactNode;
}): ReactElement | null => (
  <Show above={MOBILE_BREAKPOINT_SIZE} ssr={false}>
    {children}
  </Show>
);

export const MobileOnly = ({
  children,
}: {
  children: ReactNode;
}): ReactElement | null => (
  <Hide above={MOBILE_BREAKPOINT_SIZE} ssr={false}>
    {children}
  </Hide>
);
